/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ExportDealsReportV2MutationRequest,
  ExportDealsReportV2MutationResponse,
  ExportDealsReportV2400,
  ExportDealsReportV2500,
} from '../types/ExportDealsReportV2'

function getExportDealsReportV2Url() {
  const res = {
    method: 'POST',
    url: `/api/v1/reports/deals/export/v2/` as const,
  }
  return res
}

/**
 * @description Start an async deals report export.
 * Request body:
 * {
 * "selected_columns": ["identifier", "company", "sales_stage"],
 * "export_type": "csv",
 * "filter_params": { ... },
 * "sort": "-created"
 * }
 * Returns 202:
 * {
 * "request_id": 123,
 * "status": "pending",
 * "progress_percentage": 0,
 * "item_count": 0
 * }
 * @summary Start an async deals report export
 * {@link /api/v1/reports/deals/export/v2/}
 */
export async function exportDealsReportV2(
  data: ExportDealsReportV2MutationRequest,
  config: Partial<RequestConfig<ExportDealsReportV2MutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    ExportDealsReportV2MutationResponse,
    ResponseErrorConfig<ExportDealsReportV2400 | ExportDealsReportV2500>,
    ExportDealsReportV2MutationRequest
  >({
    method: 'POST',
    url: getExportDealsReportV2Url().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
